import React from 'react';

export const speackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    width="28"
    height="30"
    viewBox="0 0 28 30"
  >
    <defs>
      <path
        id="a"
        d="M12.387 12.61C11.135 13.376 8.911 14 7.444 14H5.15c-1.466 0-2.985-1.157-3.375-2.57L.709 7.56C.319 6.147 0 3.971 0 2.725 0 1.48 1.2.46 2.667.46h12a2.458 2.458 0 0 1 2.48 2.66l-.294 4.22c-.103 1.463-1.211 3.285-2.463 4.049l-2.003 1.222z"
      />
      <path
        id="c"
        d="M17.333 14H0V6.074C0 .324 3.88 0 8.667 0c4.786 0 8.666.323 8.666 6.074V14z"
      />
      <path id="e" d="M5 16a5 5 0 0 1-5-5V5a5 5 0 0 1 10 0v6a5 5 0 0 1-5 5z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(8.333 12)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path fill="#F3BA98" d="M0 .667h6V14H0zM6 14V.667 14" mask="url(#b)" />
        <path fill="#EAA988" d="M6 .667h11.25V14H6z" mask="url(#b)" />
      </g>
      <g transform="translate(8.333 1.333)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path fill="#F3BA98" d="M0 0h6v14H0zM6 14V0v14" mask="url(#d)" />
        <path fill="#EAA988" d="M6 0h11.333v14H6z" mask="url(#d)" />
      </g>
      <path
        fill="#99795C"
        d="M22.333 4.385S20.82 6 13.813 6C7.061 6 7.682 0 7.682 0h12.212l2.44 4.385M24.333 14.667h2V8H23v5.333c0 .737.597 1.334 1.333 1.334"
      />
      <path
        fill="#99795C"
        d="M20.333 0h-4v4h4A2.667 2.667 0 0 1 23 6.667V10h3.333V6a6 6 0 0 0-6-6"
      />
      <path fill="#CE876E" d="M16.333 16h-2.666a1.333 1.333 0 1 0 2.666 0" />
      <path
        fill="#7A4B44"
        d="M19.81 13.036c0 .493-.48.893-1.072.893-.591 0-1.071-.4-1.071-.893s.48-.893 1.071-.893c.592 0 1.071.4 1.071.893M12.667 13.036c0 .493-.48.893-1.072.893-.592 0-1.072-.4-1.072-.893s.48-.893 1.072-.893c.592 0 1.072.4 1.072.893"
      />
      <path
        fill="#8E584E"
        d="M15.667 22.667h-.861a2.472 2.472 0 0 1-2.473-2.472v-1.528H19v.666a3.334 3.334 0 0 1-3.333 3.334"
      />
      <path fill="#FFF" d="M17.667 19.333h-5.334v-.666h6l-.666.666" />
      <path
        fill="#F26867"
        d="M15.811 22.667c-1.144 0-1.644-.084-1.644-.084 0-.736.826-1.25 1.674-1.25h2.492s-1.034 1.334-2.522 1.334"
      />
      <path
        fill="#EAA988"
        d="M25.667 16.667h-2V14a2 2 0 1 1 4 0v.667a2 2 0 0 1-2 2"
      />
      <path
        fill="#99795C"
        d="M21 11.333a.666.666 0 0 1-.487-.21c-.01-.01-.477-.456-1.513-.456-.701 0-1.35.068-1.985.21a.666.666 0 1 1-.29-1.301A10.314 10.314 0 0 1 19 9.333c1.617 0 2.402.788 2.487.878A.667.667 0 0 1 21 11.333M8.989 11.366a.683.683 0 0 1-.45-.175c-.278-.243-.283-.686-.041-.964.183-.209 1.02-.894 4.085-.894a.667.667 0 0 1 0 1.334c-2.489 0-3.12.478-3.126.484a.619.619 0 0 1-.468.215M8.333 8s1.375-4 3.334-4L8.333 2v6"
      />
      <path
        stroke="#2964AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.003"
        d="M9.14 17.667v6.492C9.14 25.728 7.391 27 5.236 27"
      />
      <g transform="translate(1 10)">
        <mask id="f" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <path fill="#45A9DB" d="M0 0h5.333v16H0z" mask="url(#f)" />
        <path
          fill="#4492C9"
          d="M5.333 16V0v16M5.333 0H10v16H5.333z"
          mask="url(#f)"
        />
      </g>
      <path
        fill="#2964AA"
        d="M11 15.333H5A.666.666 0 1 1 5 14h6v1.333M11 22H5a.666.666 0 1 1 0-1.333h6V22M11 18.667H5a.666.666 0 1 1 0-1.334h6v1.334"
      />
      <path
        stroke="#2964AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.003"
        d="M5.903 27c-2.626 0-4.57-1.722-4.57-4.139v-4.888"
      />
      <path
        stroke="#2964AA"
        strokeLinejoin="round"
        strokeWidth="1.939"
        d="M6 27.333v2"
      />
    </g>
  </svg>
);
